module.exports = __webpack_public_path__ + "static/media/linkedin.8ef22143.png";